import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { Card } from '@/components/ui/Surface/Card';
import { Text } from '@/components/ui/Typography/Body/Text';
const colors = {
    gray: {
        bg: 'bg-blue-gray-100',
        textColor: 'white',
    },
    lightBlue: {
        bg: 'bg-turquoise-blue-50',
        textColor: 'base',
    },
    lightOrange: {
        bg: 'bg-orange-50',
        textColor: 'secondary',
    },
    orange: {
        bg: 'bg-orange-100',
        textColor: 'white',
    },
};
export const NumberCardListItem = (props) => {
    const { className = '', color, headText, isSkeleton = false, number } = props;
    return (_jsxs(Card, Object.assign({ className: clsx('overflow-hidden', className), isRounded: true, isShadow: true }, { children: [_jsx(Text, Object.assign({ className: clsx('h-[20px]', 'text-center', 'py-[2px]', isSkeleton ? 'bg-gray-100' : colors[color].bg), color: colors[color].textColor, size: 'xs' }, { children: isSkeleton ? '' : headText })), _jsxs("div", Object.assign({ className: clsx('relative', 'flex items-center justify-center', 'flex-col md:flex-row lg:flex-col xl:flex-row', 'pb-8 md:pb-0 lg:pb-8 xl:pb-0') }, { children: [isSkeleton ? (_jsx(Skeleton, { className: 'h-[38px] md:h-[52px] lg:h-[38px] xl:h-[52px] w-[20px]' })) : (_jsx(Text, Object.assign({ className: clsx('text-center', 'text-[29px] md:text-[40px] lg:text-[29px] xl:text-[40px]', 'leading-[38px] md:leading-[52px] lg:leading-[38px] xl:leading-[52px]'), color: 'base', fontFamily: 'alpha', isBold: true, size: 'none' }, { children: number }))), _jsx(Text, Object.assign({ className: clsx('static md:absolute lg:static xl:absolute', 'bottom-8 right-8', '!leading-none md:!leading-normal lg:!leading-none xl:!leading-normal', '-mt-[2px]'), color: 'base', size: 'xs' }, { children: isSkeleton ? (_jsx(Skeleton, { className: 'h-[12px] w-[30px]' })) : (_jsx(_Fragment, { children: "\u30C1\u30FC\u30E0" })) }))] }))] })));
};
